import React, { useState } from 'react';
import Button from '../../forms/Button';
import { QuestRoute } from '../../api/QuestRoutes';
import styled from 'styled-components';
import GetState from '../../GetState';
import LinkTo from '../../forms/LinkTo';
import Heading from '../../forms/Heading';
import Col from '../../layout/Col';
import Loading from '../../Loading';

const Wrapper = styled.div`
    position: relative;
    display: flex;
    height: auto;
    margin-bottom: 1em;
    padding: 1em;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 10px;
    border-radius: 1em;
    white-space: pre-wrap;
`
const AnswerWrap = styled.p`
    border-bottom: 1px solid rgba(137,137,137,1);
    font-size: .9em;
`
const DateLine = styled.span`
    font-size: 0.6em;
    color: grey;
`

const Surveys = ({ ...props }) => {

    const [Surveys] = GetState(QuestRoute.surveys());
    const [hideResponses, setHideResponses] = useState(false);
    
    const updateShowHide = Array.isArray(Surveys) ? new Array(Surveys.length).fill(false) : false; 
    const showHideResponses = (index, hideShow) => {
        updateShowHide[index] = !hideShow;
        setHideResponses(updateShowHide);
    }
    const [customers, setCustomers] = GetState(QuestRoute.users);
    const getFullName = (userId) => {
        const user = customers?.find(user => user.userId === userId);
        return user ? user.fullName : "User not found";
    }

    return (
        <Col>
        <Heading>Survey Responses </Heading>
        <Col>
            {
                Array.isArray(Surveys) ?
                    Surveys.length != 0 ?
                Surveys.map((ques, i) => (
                    <Wrapper key={i}>
                        <span>
                            <h5>{ques.question}</h5>
                            {<Button onClick={ () => showHideResponses(i, (hideResponses[i] ? true : false)) } 
                                    label={ (hideResponses[i] ? 'Hide' : 'Show') + ' Responses'} /> }
                                { hideResponses[i] &&  
                                ques.responses
                                    .map((resp, index) => (
                                        <>
                                            <AnswerWrap key={index}>
                                            <DateLine><LinkTo
                                                to={'/user/' + resp.customerId}>
                                                { getFullName(resp.customerId) }    
                                                </LinkTo>
                                                {" "}{new Date(resp.submittedAt).toLocaleDateString()}
                                            </DateLine> <br />
                                                {resp.customerResponse} </AnswerWrap>                              
                                        </>
                                    ))}
                        </span>
                    </Wrapper>
                )) : <Wrapper>No Surveys</Wrapper>
                : <span><Loading /></span>
            }
        </Col>
        </Col>
    );
    
}

export default Surveys;